import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import UserSettingsService from "src/services/userSettingsService";
import { useSelector } from "src/store";
import { CustomBadge } from "src/ui/shared/CustomBadge";
import { SecondaryButton } from "src/ui/shared/CustomButton";

import { selectGroups } from "@dashboard/groups/store/selectors";
import { Typography } from "@mui/material";

import { GroupFilterModal } from "../../shared/components/GroupFilterModal";

const setOverviewPageGroupFilter = (filters: number[]) => {
    UserSettingsService.setWorkspaceValue("overviewPage.groupFilter", filters);
};

type FormValues = {
    [key: string]: boolean;
};

type Props = {
    filter: number[];
    setFilter: (filter: number[]) => void;
};

export const Filter = ({ filter, setFilter }: Props) => {
    const [open, setOpen] = useState(false);
    const { t } = useTranslation(["pages"]);
    const groups = useSelector(selectGroups);
    const initialValues = groups.reduce((acc, group) => ({ ...acc, [`$${group.id}`]: filter.includes(group.id) }), {});

    const onSubmit = (values: FormValues) => {
        const groupIds = Object.keys(values)
            .filter((key) => values[key])
            .map((key) => parseInt(key));

        setFilter(groupIds);
        setOverviewPageGroupFilter(groupIds);
    };

    return (
        <React.Fragment>
            <CustomBadge badgeContent={filter.length}>
                <SecondaryButton startIcon={<i className="fas fa-filter" />} onClick={() => setOpen(true)}>
                    <Typography>{t("pages:overviewPage.filter")}</Typography>
                </SecondaryButton>
            </CustomBadge>

            <GroupFilterModal open={open} initialValues={initialValues} setOpen={setOpen} onSubmit={onSubmit} />
        </React.Fragment>
    );
};
